import React from 'react'
import { Link as RouterLink } from 'react-router-dom'
import { Flex, Button, Heading } from '@chakra-ui/react'

import { MainLayout } from 'layouts'

export const LogoutPage = () => (
  <MainLayout hideProfile>
    <Flex flex={1} direction='column' align='center' justify='center'>
      <Heading>Sessão terminada</Heading>
      <Button mt={5} as={RouterLink} to='/login'>
        Voltar a entrar
      </Button>
    </Flex>
  </MainLayout>
)

export default LogoutPage
